import {Component, OnInit, Input} from '@angular/core';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import {CookieService} from 'ngx-cookie-service';


@Component({
    selector: 'eshop-btn',
    templateUrl: './eshop-btn.html',
    styleUrls: ['./eshop-btn.scss'],
    standalone: false
})
export class EshopBtnComponent {

    @Input() dataText: string;
    @Input() dataHref;
    @Input() dataClasses;

    constructor(protected restUrlsConfig: RestUrlsConfig,
                private cookie: CookieService) {
    }


    setEshop() {
        this.cookie.set('eshopMode', 'true', null, '/', this.restUrlsConfig.ssoDomain, false, 'Lax');
    }
}
